import React from 'react';
import styles from './LandingPage.module.css';

function LandingPage() {
    return (
        <div className={styles.container}>
            <div className={styles.info_container}>
                <div className={styles.info_left}>
                    <h1 className={styles.info_header}>
                        CONNECT WITH ME
                    </h1>
                    <p className={styles.info_body}>
                        With 35+ years of market experience in the greater Spokane Region
                        Stu can help find you a new home.
                    </p>
                    <button className={styles.contact_button}>CONTACT ME</button>
                </div>
                <div className={styles.info_right}>
                    <div className={styles.info_box}>
                        <h1>
                            $15.8 M
                        </h1>
                        <p>
                            IN CURRENT LISTINGS
                        </p>
                    </div>
                    <div id={styles.middle_box} className={styles.info_box}>
                        <h1>
                            $85.2 M
                        </h1>
                        <p>
                            SOLD IN 2025
                        </p>
                    </div>
                    <div className={styles.info_box}>
                        <h1>
                            37.5 YEARS
                        </h1>
                        <p>
                            OF MARKET EXPERIENCE
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LandingPage;

